import jsonView from "@pgrabovets/json-view";

window.addEventListener('json-view', (event) => {
    const jsonBlocks = document.querySelectorAll('[data-json-view]');
    if (jsonBlocks.length === 0) {
        return;
    }

    jsonBlocks.forEach((jsonBlock) => {
        jsonBlock.style.display = 'none';
        const tree = jsonView.create(jsonBlock.textContent);

        jsonView.render(tree, jsonBlock.parentNode);
        jsonView.expand(tree);
    })
});
